import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMPANY_AUDIO_RECORDINGS_ACTION_TYPE } from '../actions';

const initialState = {};

const audioRecordings = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMPANY_AUDIO_RECORDINGS_ACTION_TYPE.GET_AUDIO_RECORDINGS:
        return payload || initialState;

      case COMPANY_AUDIO_RECORDINGS_ACTION_TYPE.EDIT_AUDIO_RECORDING_CONTENT:
      case COMPANY_AUDIO_RECORDINGS_ACTION_TYPE.UPDATE_AUDIO_RECORDING:
      case COMPANY_AUDIO_RECORDINGS_ACTION_TYPE.CREATE_AUDIO_RECORDING:
      case COMPANY_AUDIO_RECORDINGS_ACTION_TYPE.GET_AUDIO_RECORDING_URL:
        draft[payload.audioRecordingId] = {
          ...(draft[payload.audioRecordingId] || {}),
          ...payload,
        };

        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default audioRecordings;
